import Button from 'lib/ui/Button'
import React from 'react'
import Copy from '@material-ui/icons/FileCopyOutlined'

export default function CopyButton(props: {value: string}) {
  const {value} = props

  const [isCopied, setIsCopied] = React.useState(false)

  const copyCode = () => {
    navigator.clipboard.writeText(value)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 1000)
  }

  return (
    <Button variant="text" onClick={copyCode}>
      <Copy fontSize="small" style={{marginRight: 4}} onClick={copyCode} />{' '}
      {isCopied ? 'Copied' : 'Copy code'}
    </Button>
  )
}
